// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useCallback } from "react";

// Create the AuthContext
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // { user_id, username }
    const [isAuthInitialized, setIsAuthInitialized] = useState(false);

    const refreshSession = useCallback(async () => {
        try {
            const res = await fetch("/api/session", { credentials: "include" });
            const data = await res.json().catch(() => ({}));
            if (data && data.authenticated) {
                setUser({ user_id: data.user_id, username: data.username });
            } else {
                setUser(null);
            }
        } catch (e) {
            setUser(null);
        } finally {
            setIsAuthInitialized(true);
        }
    }, []);

    useEffect(() => {
        refreshSession();
        const onFocus = () => refreshSession();
        window.addEventListener('focus', onFocus);
        return () => {
            window.removeEventListener('focus', onFocus);
        };
    }, [refreshSession]);

    const loginSuccess = () => refreshSession();
    const logoutLocal = () => setUser(null);

    return (
        <AuthContext.Provider value={{ user, isAuthInitialized, refreshSession, loginSuccess, logoutLocal }}>
            {children}
        </AuthContext.Provider>
    );
};
